import { Dispatch } from 'redux'

import { fetchProviders, Provider } from '~/entities/provider'
import {
  GET_PROVIDERS_SUCCESS,
  GET_PROVIDERS_ERROR,
  UPDATE_PROVIDER_PRACTICING_STATES,
} from './actionTypes'
import { logger } from '~/shared/lib/logger'

const getProvidersSuccess = (providers: Provider[]) => ({
  type: GET_PROVIDERS_SUCCESS as typeof GET_PROVIDERS_SUCCESS,
  providers,
})

const getProvidersError = (error: string) => ({
  type: GET_PROVIDERS_ERROR as typeof GET_PROVIDERS_ERROR,
  error,
})

export function getProviders() {
  return async (dispatch: Dispatch) => {
    try {
      const providers = await fetchProviders()
      return dispatch(getProvidersSuccess(providers))
    } catch (error) {
      logger.error('[Providers] fetch providers', error)
      return dispatch(getProvidersError('Problem fetching providers'))
    }
  }
}

type PracticingStates = NonNullable<Provider['provider_fields']>['practicing_states']

export const updateProviderPracticingStates = (id: number, practicingStates: PracticingStates) => ({
  type: UPDATE_PROVIDER_PRACTICING_STATES as typeof UPDATE_PROVIDER_PRACTICING_STATES,
  payload: {
    id,
    practicingStates,
  },
})

export type ProvidersAction =
  | ReturnType<typeof getProvidersSuccess>
  | ReturnType<typeof getProvidersError>
  | ReturnType<typeof updateProviderPracticingStates>
